import { InternalContact } from './internalContact';
import { Office } from './office';

export const contact = { ...InternalContact, ...Office };
